import { Space } from "antd";
import cuid from "cuid";
import PropTypes from "prop-types";
import { BiPlus } from "react-icons/bi";
import Button from "shared/components/Button";
import { DEFAULT_CONDITION_OPERATION } from "./catalog";
import ConditionRow from "./ConditionRow";

const ConditionListEditor = ({ conditions, variables, labels, onChange }) => {
  const updateCondition = (index, updater) =>
    onChange(
      conditions.map((condition, i) =>
        i === index ? updater(condition) : condition,
      ),
    );

  return (
    <Space direction="vertical" size={12} className="canvas-editor__full-width">
      {(conditions || []).map((condition, index) => (
        <ConditionRow
          key={condition.id || index}
          condition={condition}
          index={index}
          variables={variables}
          labels={labels}
          onUpdate={(updater) => updateCondition(index, updater)}
          onRemove={() => onChange(conditions.filter((_, i) => i !== index))}
        />
      ))}
      <Button
        type="primary"
        onClick={() =>
          onChange([
            ...(conditions || []),
            {
              id: cuid(),
              leftOperand: {},
              rightOperand: {},
              operation: DEFAULT_CONDITION_OPERATION,
            },
          ])
        }
      >
        <BiPlus size={20} /> {labels.ADD}
      </Button>
    </Space>
  );
};

ConditionListEditor.propTypes = {
  conditions: PropTypes.array,
  variables: PropTypes.array,
  labels: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};

ConditionListEditor.defaultProps = {
  conditions: [],
  variables: [],
  labels: {},
};

export default ConditionListEditor;
